import styled from "styled-components";

const FieldWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.space[2]};
`;

export default FieldWrap;
